var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Frame',{attrs:{"title":"Integraciones","loading":_vm.loading}},[_c('Grid',{attrs:{"data":_vm.data,"columns":_vm.columns,"addText":"Agregar configuración"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }